import React from "react";

/**
 * The full-screen takeover for a suspended shop — replaces every screen
 * (back-office and register alike, they sit behind the same gate) with the
 * operator's own message, instead of the account just looking broken.
 */
export default function SuspendedScreen({ shopName, message, onSignOut }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
        <div className="inline-block p-4 bg-red-100 rounded-full mb-4">
          <span className="text-4xl">🔒</span>
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">
          {shopName ? `${shopName} is suspended` : "This account is suspended"}
        </h1>
        <p className="text-gray-600 mb-6 whitespace-pre-line">
          {message || "Contact the shop for details."}
        </p>
        <button
          onClick={onSignOut}
          className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 rounded-lg transition-all shadow-lg hover:shadow-xl"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
